
/***************************************************
 * ページ内スムーススクロール
 ***************************************************/

window.addEventListener("DOMContentLoaded", () => {
    const navLinks = document.querySelectorAll("a");
    navLinks.forEach(navLink => {
      if (
      navLink.hasAttribute("href") &&
      navLink.getAttribute("href").startsWith("#"))
      {
        navLink.addEventListener("click", e => {
          e.preventDefault();
          gsap.to(window, {
            duration: 1,
            ease: "power3.inOut",
            invalidateOnRefresh: true,
            scrollTo: {
              y: navLink.getAttribute("href"),
              offsetY: 40,
              autoKill: false } });
        });
      }
    });
    });